export default "ALTER TABLE `chat_interaction` DROP COLUMN `response_latency_ms`;"